import { ChangePassword } from "./ChangePassword";
import { TwoFactorAuthentication } from "./TwoFactorAuthentication";
import { WithdrawalVerification } from "./WithdrawalVerification";
import { IdentityVerification } from "./IdentityVerification";
import { SecurityWrapper } from "./Security.styles";

export const Security = () => {
  return (
    <SecurityWrapper>
      <div className="authentication-container">
        <TwoFactorAuthentication />
        <WithdrawalVerification />
      </div>
      <ChangePassword />
      <IdentityVerification />
    </SecurityWrapper>
  );
};
